import axiosInstance from "../utils/axios";

export const ViewAppeal = async (stdId, assId) => {
  return await axiosInstance().get(`/viewAppeal?student_id=${stdId}&assessment_id=${assId}`);
};

export const ApproveOrDeclineAppeal = async (data) => {
  return await axiosInstance().post("/approveOrDeclineAppeal", data);
};

export const GetStudentAppealAuditTrail = async (data) => {
  return await axiosInstance().post("/getStudentAppealAuditTrail", data);
};
